export default function Services() {
  const services = [
    {
      icon: 'ri-briefcase-line',
      title: 'General Business Services',
      description: 'Operational support, consulting, and structured solutions designed to improve efficiency and performance.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Property Support Services',
      description: 'Property maintenance coordination, asset upkeep, and support services for residential and commercial properties.'
    },
    {
      icon: 'ri-car-line',
      title: 'Automotive Services',
      description: 'Vehicle sourcing, logistics support, and licensed automotive transaction services.'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Asset Management',
      description: 'Oversight, coordination, and management of physical and operational assets across business portfolios.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-grey-50 relative">
      <div className="absolute top-0 left-0 right-0 h-px bg-grey-200"></div>
      
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-navy-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-grey-600 max-w-3xl mx-auto">
            Comprehensive solutions across multiple verticals, designed to support your business and operational needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-10 rounded-lg border border-grey-200 hover:border-navy-400 transition-all hover:shadow-xl group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-navy-700 rounded-lg mb-6 group-hover:bg-navy-600 transition-colors">
                <i className={`${service.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-4">
                {service.title}
              </h3>
              <p className="text-grey-600 leading-relaxed text-base">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-grey-200"></div>
    </section>
  );
}
